import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpService } from '../http.service';
import { HelperService } from '../helper.service';
import { HttpClient } from '@angular/common/http';
import { FormBuilder } from '@angular/forms';
import { map } from 'rxjs/operators';
import { KrollCheckQuantity, MenuType, OrderStatus } from '../../constants/KRollConstants';
import { RouteConstants } from '../../constants/RouteConstants';
import { FormService } from '../form.service';
import { BehaviorSubject, of } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class KRollService {
  tenant: any = localStorage.getItem('tenant')
  controller: string = 'admin/kroll';
  controller2: string = 'admin/wylo/kroll';
  nursingHomes: BehaviorSubject<any[]> = new BehaviorSubject(new Array);
  constructor(
    private httpService: HttpService,
    public helperService: HelperService,
    public httpClient: HttpClient,
    public fb: FormBuilder,
    private RouteConstants: RouteConstants,
    public formService: FormService,
    private router: Router) {
  }
  get_location() {
    return this.httpService.get(`${this.controller}/get_location`).pipe(map((res: any) => {
      let response: any = res;
      if (response['success']) {
        this.formService.setSelectedLocationVal(this.helperService.getLocalStorage('serverLocation') == undefined ? response['data'][0].id : this.helperService.getLocalStorage('serverLocation'));
      }
      return response;
    }));
  }
  get_patient_orders(obj: any) {
    return this.httpService.post(`${this.controller}/get_patient_orders`, obj).pipe(map((res: any) => {
      let response: any = res;
      if (response['body']['success']) {
        if (response['body']['data'] && response['body']['data'].list) {
          response['body']['data'].list = response['body']['data'].list.reverse().map((m: any) => {
            return {
              ...m,
              DeliveryPartnerID: m.deliver_partner?.id ? m.deliver_partner.id : m.DeliveryPartnerID,
              isSelect: false,
              acuteRXID: {
                isAcuteRXInputShow: false,
                error: "",
                rxIds: [],
                isLoading: false
              },
              RXIds: m.sale_order_rx_detail.map((mm: any) => mm.RxNum ? mm.RxNum : '-'),
              Packaging: (m.sale_order_rx_packagings.length > 0) ? m.sale_order_rx_packagings.map((m: any) => `${m.inventory_types.type}(${m.Quantity})`).join(",") : "N/A",
              PackagingCost: (m.sale_order_rx_packagings.length > 0) ? m.sale_order_rx_packagings.reduce((acc: number, val: any) => acc + val.Price, 0) : "N/A",
              TotalMedCost: m.sale_order_rx_detail.reduce((acc: number, val: any) => {
                acc += ((+val.Cost) + (+val.Markup) + (+val.Fee))
                if(this.tenant == 'wylo'){
                  if(val.additional_cost !== null && val.additional_cost !== undefined) {
                      acc += (+val.additional_cost);
                  }
                }
                return acc
              }, 0).toFixed(2),
              // PaymentDue: [2, 3, 4].includes(m.SalesOrderStatusID) ? 0 : m.sale_order_rx_detail.flatMap((fm: any) => fm.kroll_rx_pln).filter((f: any) => f.SubPlanCode.toLocaleLowerCase().match("cash")).reduce((acc: any, val: any) => acc + (+val.Pays), 0),
              PaymentDue: [2, 3, 4].includes(m.SalesOrderStatusID) ? 0 : m.orderSummery?.total,
              DeliveryPartner: m.deliver_partner?.name,
              get IsAutoPay() {
                return (this.PaymentDue && m.CardExit && (m.SalesOrderStatus == OrderStatus.Unpaid || m.SalesOrderStatus == OrderStatus.WaitingForPayment)) ? true : false
              },
              SignatureRequired: true,
              Measurments: {
                Weight: 1,
                Height: 8,
                Width: 8,
                Length: 4,
              }
            }
          });
        }
      }
      else {
        response.list = [];
      }
      return response;
    }));
  }

  get_patient_draft_orders(obj: any) {
    return this.httpService.post(`${this.controller2}/get_patient_draft_orders`, obj).pipe(map((res: any) => {
      let response: any = res;
      if (response['body']['success']) {
        if (response['body']['data'] && response['body']['data'].list) {
          response['body']['data'].list = response['body']['data'].list.reverse().map((m: any) => {
            return {
              ...m,
              isSelect: false,
              acuteRXID: {
                isAcuteRXInputShow: false,
                error: "",
                rxIds: [],
                isLoading: false
              },
              RXIds: m.sale_order_rx_detail.map((mm: any) => mm.RxNum ? mm.RxNum : '-'),
            }
          });
        }
      }
      else {
        response.list = [];
      }
      return response;
    }));
  }

  get_sales_order_status(payload: any) {
    this.httpService.post(`${this.controller}/get_sales_order_status`, payload).subscribe((res: any) => {
      let response: any = res;
      if (response['body']['success']) {
        // let allObj = {
        //   "id": 0,
        //   "type": "All",
        //   "menu": "sale",
        //   "status": 1,
        //   "sale_orders_count": response['data'].reduce((acc: number, val: any) => acc + val.sale_orders_count, 0)
        // }
        // response['data'].unshift(allObj);
        // response['data'] = response['data'].map((m: any) => ({ ...m, isChecked: false }));
        //no need refundes status after discuss rashi
        response['body']['data'] = response['body']['data'].filter((m: any) => m.id !== 12 && m.id !== 8);
        if (this.formService.saleOrderForm.value.salesOrderStatus.length > 0 && this.formService.processedOrderForm.value.processedOrderStatus.length > 0) {
          let sale_orders_count = (id: number) => response['body']['data'].find((f: any) => f.id == id).sale_orders_count;
          this.formService.saleOrderForm.value.salesOrderStatus.forEach((item: any, index: number) => {
            this.formService.getSalesOrderFormStatusArr.controls[index].get('sale_orders_count')!.setValue(sale_orders_count(item.id));
          });
          this.formService.processedOrderForm.value.processedOrderStatus.forEach((item: any, index: number) => {
            this.formService.getProcessedOrderFormStatusArr.controls[index].get('sale_orders_count')!.setValue(sale_orders_count(item.id));
          });
        }
        else {
          this.formService.setSalesOrderStatusToForm(response['body']['data'].filter((f: any) => f.menu == MenuType.Sale));
          let { salesOrderStatus } = this.formService.saleOrderForm.value;
          this.RouteConstants.setSaleOrderValue(salesOrderStatus);

          this.formService.setProcessedOrderStatusToForm(response['body']['data'].filter((f: any) => f.menu == MenuType.Processed));
          let { processedOrderStatus } = this.formService.processedOrderForm.value;
          this.RouteConstants.setProcessedOrderValue(processedOrderStatus);
        }
      }
      // return response;
    });
  }
  get_sales_order_status_for_update() {
    return this.httpService.get(`admin/shipping/get_status`)
  }
  getSurveyStatusList(){
    return this.httpService.get(`admin/survey/status`)
  }
  updateSurveyStatus(obj: any) {
    return this.httpService.post(`admin/survey/status/update`, obj);
  }
  addSurveyAssessment(obj: any) {
    return this.httpService.post(`admin/survey/add/assessment`, obj);
  }
  save_sales_order_packaging(obj: any) {
    return this.httpService.post(`${this.controller}/save_sales_order_packaging`, obj);
  }
  checkQuantity(obj: KrollCheckQuantity) {
    return this.httpService.post(`${this.controller}/check_quantity_inventory`, obj);
  }
  get_nursing_home(server_location: string | number) {
    this.httpService.post(`${this.controller}/get_nursing_home`, { server_location: server_location }).subscribe(res => {
      if (res.body?.success) {
        this.nursingHomes.next(res.body.data);
      }
      else {
        this.nursingHomes.next(new Array);
      }
    });
    return of();

  }
  save_sales_order_notes(obj: any) {
    return this.httpService.post(`${this.controller}/save_sales_order_notes`, obj);
  }
  delete_sales_order(obj: any) {
    return this.httpService.post(`${this.controller}/delete_sales_order`, obj);
  }

  sales_order_process_payment(obj: any) {
    if(this.tenant == 'qc' || this.tenant == 'ml_qc'){
      return this.httpService.post(`admin/moneris/sale_order_payment`, obj);
    }else{
      return this.httpService.post(`${this.controller}/sales_order_process_payment`, obj);
    }
  }

  // sales_order_process_payment(obj: any) {
  //   if (this.tenant == 'pl' && obj?.cardFrom == 'moneris') {
  //     return this.httpService.post(`admin/moneris/sale_order_payment`, obj);
  //   } else {
  //     return this.httpService.post(`${this.controller}/sales_order_process_payment`, obj);
  //   }
  // }

  massUpdateStatusProcessOrder(obj: any){
    return this.httpService.post(`/admin/bulk_update_status`, obj);
  }
  get_patient_order_acute_rxnums(obj: any) {
    return this.httpService.post(`${this.controller}/get_patient_order_acute_rxnums`, obj).pipe(map((res: any) => {
      let response: any = res;
      if (response['body']['code'] == 200 || response['body']['code'] == 206) {
        response['body']['data'] = response['body']['data'].map((m: any) => {
          return {
            ...m,
            isSelect: false,
            acuteRXID: {},
            RXIds: m.sale_order_rx_detail.map((mm: any) => mm.RxNum ? mm.RxNum : '-'),
            Packaging: (m.sale_order_rx_packagings.length > 0) ? m.sale_order_rx_packagings.map((m: any) => `${m.inventory_types.type}(${m.Quantity})`).join(",") : "N/A",
            PackagingCost: (m.sale_order_rx_packagings.length > 0) ? m.sale_order_rx_packagings.reduce((acc: number, val: any) => acc + val.Price, 0) : "N/A",
            TotalMedCost: m.sale_order_rx_detail.reduce((acc: number, val: any) => {
              acc += ((+val.Cost) + (+val.Markup) + (+val.Fee))
              return acc
            }, 0).toFixed(2),
            PaymentDue: [2, 3].includes(m.SalesOrderStatusID) ? 0 : m.sale_order_rx_detail.flatMap((fm: any) => fm.kroll_rx_pln).filter((f: any) => f.SubPlanCode.toLocaleLowerCase().match("cash")).reduce((acc: any, val: any) => acc + (+val.Pays), 0),
            get IsAutoPay() {
              return (this.PaymentDue && m.CardExit && (m.SalesOrderStatus == OrderStatus.Unpaid || m.SalesOrderStatus == OrderStatus.WaitingForPayment)) ? true : false
            },
            SignatureRequired: true,
            Measurments: {

            }
          }
        });
      }
      return response;
    }));
  }

  downloadPdf(payload: any) {
    return this.httpService.post(`${this.controller}/salesInvoice`, payload)
  }
  changeTenant(obj:any) {
    return this.httpService.post(`admin/get/tenant/dashboard`,obj)
  }

  get_discover_services(payload:any) {
    return this.httpService.post(`admin/shipping/cp/get_discover_services`,payload)
  }
  get_options(payload:any) {
    return this.httpService.post(`admin/shipping/cp/get_options`,payload)
  }
  removeAdditionalCoverage(obj: any) {
    return this.httpService.post(`admin/kroll/remove_additional_coverage`, obj);
  }

  downloadOrderLabel(obj:any) {
    return this.httpService.post(`admin/kroll/get_patient_orders_label`,obj)
  }
  updateOrderRxids(obj:any) {
    return this.httpService.post(`admin/kroll/update_patient_krollid`,obj)
  }

  getMWSOptions() {
    return this.httpService.get(`admin/shipping/get_mws_options`)
  }

}
